{
  "dss": {
    "button": {
      "back": "Takaisin",
      "cancel": "Peruuta",
      "close": "Sulje",
      "confirmDelete": "Kyllä, poista",
      "continue": "Jatka",
      "logout": "Kirjaudu ulos",
      "passwordReset": "Salasanan palautus",
      "save": "Tallenna",
      "verify": "Vahvista"
    },
    "error": {
      "403": "Sinulla ei ole pääsyä tälle sivulle.",
      "404": "Tätä sivua ei ole olemassa.",
      "generic": "On tapahtunut virhe. Yritä myöhemmin uudelleen.",
      "throttling": "Liian monta yritystä. Tämä toiminto on estetty hetkeksi.",
      "title": "Virhe",
      "title403": "Pääsy evätty",
      "title404": "Ei löydy"
    },
    "footer": {
      "imprint": "Vastaava julkaisija",
      "legalEntity": "Andreas Stihl Oy, 01510 Vantaa",
      "privacy": "Tietosuojakäytäntö",
      "terms": "Yleiset ehdot"
    },
    "label": {
      "CRMAccountNumber": "CRM Account Number",
      "contact": "Ota yhteyttä",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "Etunimi",
      "help": "Help",
      "language": "Kieli",
      "lastname": "Sukunimi",
      "male": "Mr.",
      "needHelp": "Tarvitsetko apua?",
      "newPassword": "Uusi salasanasi",
      "newPassword2": "Vahvista uusi salasanasi",
      "oldPassword": "Nykyinen salasanasi",
      "organization": "Organisaatio",
      "password": "Password",
      "required": "vaadittu",
      "salutation": "Sukupuoli",
      "select": "Valitse"
    },
    "link": {
      "contact": "https://support.stihl.com/fi-FI/websso-contact/",
      "faq": "https://support.stihl.com/fi-FI/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Vahvista rekisteröinti",
        "wait": "Odota tilin vahvistuksen loppuunsaattamista."
      },
      "otp": {
        "btnResend": "Vahvistuskoodin uudelleenlähetys sähköpostitse",
        "msg": {
          "invalidOTP": "Syötetty kertakäyttösalasana on virheellinen.",
          "resendFail": "Koodia ei onnistuttu lähettämään uudelleen. Yritä uudelleen myöhemmin."
        },
        "spamDetail": "Tarkista postilaatikkosi ja roskapostikansiosi STIHL Supportin sähköpostin varalta. (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Etkö saanut sähköpostia?",
        "subtitle": "Jatkaaksesi sinun on vahvistettava sähköpostiosoitteesi.",
        "title": "Vahvista käyttäjätilisi",
        "txtVerifyMail": "Syötä uusi vahvistuskoodi, jonka lähetimme sähköpostiosoitteeseesi {email}."
      },
      "personal": {
        "msg": {
          "noChange": "Ei ole mitään päivitettävää.",
          "updateError": "Henkilötietoja ei ole päivitetty.",
          "updated": "Henkilötiedot päivitettiin.",
          "userLoadErr": "Virhe käyttäjätietojen lataamisessa. Yritä myöhemmin uudelleen."
        },
        "secOrganization": "Organisaatio",
        "secPersonal": "Henkilö",
        "secSettings": "Halutut asetukset",
        "title": "Henkilökohtaiset tiedot"
      },
      "postPwSet": {
        "info": "Voit nyt käyttää uutta salasanaasi.",
        "link_name": "Jatka itsepalveluun",
        "link_url": "/user/ui/",
        "title": "Salasanasi on vaihdettu"
      },
      "resetPW": {
        "title": "Nollaa salasana"
      },
      "security": {
        "2fa": {
          "availableMethods": "Käytettävissä olevat 2FA-menetelmät:",
          "info": "Kaksivaiheinen todennus (2FA) on turvaominaisuus, joka lisää tilillesi ylimääräisen suojauskerroksen. Se edellyttää kahden kirjautumistavan käyttöä käyttäjätunnuksen ja salasanan sijaan.",
          "method": {
            "email": "Sähköposti",
            "emailDesc": "Saat kertakäyttöisiä koodeja sähköpostitse todennuspyyntöjen suorittamiseksi.",
            "oath": {
              "add": {
                "button": "Rekisteröi Authenticator-sovellus"
              }
            }
          }
        },
        "authenticator": "Authenticator-sovellus",
        "infoFederatedAccount": "Tätä tiliä hallinnoi organisaatiosi identiteetintarjoaja, joten salasanaa ei voi vaihtaa täällä. Vaihtaaksesi salasanan kirjaudu sisään organisaatiosi kirjautumissivun kautta tai ota yhteyttä IT-järjestelmänvalvojaasi.",
        "lastUse": "Viimeksi käytetty {0}.",
        "msg": {
          "invalidPassword": "Annettu nykyinen salasana on virheellinen.",
          "passwordAlreadyUsed": "Viimeisimpiä viittä salasanaa ei voida käyttää uudelleen.",
          "pwUpdateError": "Salasanan vaihtamisessa tapahtui virhe.",
          "pwUpdated": "Salasana on vaihdettu."
        },
        "noDevice": "Ei määritetty",
        "oathAdd": {
          "appInfo": "STIHL-kirjautumisen helpottamiseksi voit käyttää todennussovelluksia, kuten {0}, {1}, {2} jne., luodaksesi kertakäyttöisen salasanan, jota käytetään toisena tekijänä kirjautumisprosessissa.<br/>Jos olet kadottanut tai unohtanut mobiililaitteesi, voit silti käyttää sähköpostitse lähetettyä 2FA-koodia milloin tahansa.<br/><br/>Noudata alla olevia ohjeita määrittääksesi todennuslaitteesi.",
          "badCode": "Virheellinen koodi, yritä uudelleen.",
          "error": "Todennuslaitteen rekisteröinnissä tapahtui virhe.",
          "headScan": "1. Skannaa QR-koodi todennussovelluksellasi",
          "headVerify": "2. Vahvista koodi",
          "infoKey": "asennusavain",
          "infoKeyTitle": "Kaksivaiheinen salaisuutesi",
          "infoScanBottom": "Eikö skannaus onnistu? Voit määrittää todennussovelluksesi manuaalisesti sovelluksella {0}.",
          "infoVerify": "Syötä todennussovelluksesi luoma koodi.",
          "success": "Todennuslaitteesi on rekisteröity. Voit nyt kirjautua sillä sisään.",
          "title": "Rekisteröi kaksivaiheisen todennuslaitteesi"
        },
        "oathDelete": {
          "error": "Todennuslaitetta poistettaessa tapahtui virhe.",
          "success": "Todennuslaite poistettiin."
        },
        "passkeys": {
          "about": {
            "info1": "Salasanat ovat kryptografisten avainten pareja (julkinen avain ja yksityinen avain), jotka hallitsemasi todennustyökalu tallentaa. Todennustyökalu voi todistaa, että käyttäjä on läsnä ja hänellä on oikeus käyttää salasanaa. Todentajat todistavat valtuutuksen PIN-koodilla, salasanalla, biometrisellä tunnisteella tai laitteen salasanalla todentajan ominaisuuksista ja määrityksistä riippuen. Todentajia on saatavilla monissa muodoissa, kuten iPhone- tai Android-laitteella, Windows Hellolla, FIDO2-laitteiston suojausavaimella tai salasananhallintaohjelmalla.",
            "info2": "Kun kirjaudut STIHLiin salasanalla, todennustyökalusi käyttää julkisen avaimen salausta henkilöllisyytesi todistamiseen STIHLille lähettämättä salasanaa koskaan. Salasanat on sidottu verkkosivuston verkkotunnukseen, kuten stihl-sso.com, ja ne vaativat suojatun yhteyden, mikä tarkoittaa, että verkkoselain kieltäytyy todentamasta itseään näyttävälle tietojenkalastelusivustolle. Nämä ominaisuudet tekevät salasanoista erittäin suojattuja tietojenkalastelulta ja paljon vaikeampia hyökätä niihin kuin tekstiviesteihin tai TOTP 2FA:han, joita voidaan kalastelun kohteeksi.",
            "info3": "Pilvipohjaiset salasanapalvelut mahdollistavat salasanojen synkronoinnin laitteiden välillä (kuten Apple-laitteet, Android-laitteet tai salasananhallintaohjelmat), jotta niitä voidaan käyttää useammasta paikasta ja ne katoavat vähemmän helposti. Kun olet määrittänyt synkronoidun salasanan yhteen laitteeseen, kyseinen salasana on käytettävissä useilla laitteilla, jotka käyttävät samaa palvelua. Jos esimerkiksi rekisteröit salasanan iCloud-tilillesi MacBookin Touch ID:n avulla, voit käyttää kyseistä salasanaa kasvojesi, sormenjälkesi, PIN-koodisi tai laitteen salasanasi kanssa vaihtokelpoisesti useilla laitteilla, jotka on linkitetty samaan iCloud-tiliin.",
            "title": "Tietoja salasanoista"
          },
          "add": {
            "button": "Lisää uusi salasana",
            "error": "Uuden salasanan lisäämisessä tapahtui virhe.",
            "success": "Uusi salasana lisättiin."
          },
          "delete": {
            "button": "Poista salasana",
            "error": "Tätä salasanaa poistettaessa tapahtui virhe.",
            "success": "Salasana poistettiin."
          },
          "edit": {
            "error": "Tunnusavaimen nimen tallentamisessa tapahtui virhe.",
            "name": "Tunnusavaimen nimi",
            "success": "Tunnusavaimen nimi päivitettiin.",
            "title": "Anna tunnusavaimellesi nimi, jolla se erottuu muista tunnuksista"
          },
          "info": "Tunnusavain on yksinkertainen ja turvallinen vaihtoehto salasanoille, jotka vahvistavat henkilöllisyytesi kosketuksen, kasvojentunnistuksen, laitteen salasanan tai PIN-koodin avulla.",
          "none": "Tunnusavainta ei ole määritetty.",
          "reallyDelete": "Oletko varma, että haluat poistaa tunnusavaimen?",
          "registeredPasskeys": "Rekisteröidyt tunnaasi:",
          "title": "Tunnusavaimet"
        },
        "reallyDeleteDevice": "Oletko varma, että haluat poistaa todennuslaitteen?",
        "secMFA": "Kaksivaiheinen todennus",
        "secPwdChange": "Vaihda salasana",
        "title": "Turvallisuus"
      },
      "setPW": {
        "acceptTC": "Vahvista {terms} ja lue {privacy}.",
        "killSSO": "Mitätöi kaikki aktiiviset istunnot",
        "msg": {
          "tokenExpired": "Salasanalinkki tai koodi on vanhentunut. Seuraa linkkiä salasanan palauttamiseksi: {link}."
        },
        "privacy": "Tietosuojakäytäntö",
        "terms": "Ehdot ja edellytykset",
        "title": "Syötä uusi salasana"
      }
    },
    "validations": {
      "hasDigit": "Sisältää numeron (numerot)",
      "hasLowercase": "Täytyy sisältää pieniä kirjaimia",
      "hasSpecial": "Täytyy sisältää erikoismerkkejä: {chars}",
      "hasUppercase": "Täytyy sisältää isoja kirjaimia",
      "invalidCharacters": "Sisältää virheellisiä merkkejä",
      "maxLength": "Suurin sallittu {max} merkki",
      "minLength": "Vähintään {min} vaadittavaa merkkiä",
      "notSameAsEmail": "Liian samanlainen kuin sähköpostiosoite",
      "onlyValidCharactersAllowed": "Vain kirjaimet, numerot ja välilyönnit sallitaan.",
      "required": "Vaadittu arvo",
      "sameAsPassword": "Salasana ja sen vahvistus eivät täsmää",
      "tcAccepted": "Huomioithan käyttöehtomme ja tietosuojakäytäntömme.",
      "validEmail": "Virheellinen sähköpostiosoite.",
      "validOTP": "Syötä vahvistuskoodi."
    }
  }
}
